import React, {useState} from 'react';
import {
  Avatar,
  CssBaseline,
  TextField,
  Typography,
  Container,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  useTheme
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { escape } from "lodash";
import logo from '../../hermeslogo.png';
import {baseUrlFunc} from "../Constants";
import { Card, Button } from "../../components/primitives";
import { ScaleIn, FadeIn } from "../../components/motion";


export default function SignIn(props) {
    const theme = useTheme();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleUsernameChange = (event) => {
        setUsername(event.target.value);

    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <FadeIn>
                <ScaleIn delay={0.1}>
                    <Card
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            p: 4,
                        }}
                        accent={theme.palette.primary.main}
                    >
                        <Avatar
                            src={logo}
                            sx={{
                                width: 64,
                                height: 64,
                                mb: 2
                            }}
                        />
                        <Typography
                            component="h1"
                            variant="h4"
                            sx={{
                                fontWeight: 700,
                                mb: 3,
                                fontFamily: theme.typography.h1.fontFamily
                            }}
                        >
                            Hermes
                        </Typography>
                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                mt: 1,
                                py: 1.5,
                                backgroundColor: theme.palette.success.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.success.dark,
                                }
                            }}
                            href={`${baseUrlFunc()}oauth2/authorization/epam?redirectPath=${escape(useLocation().pathname)}`}
                        >
                            Sign In with SSO
                        </Button>
                        <Accordion
                            sx={{
                                width: '100%',
                                mt: 2,
                                boxShadow: 'none',
                                '&:before': {
                                    display: 'none',
                                }
                            }}
                        >
                            <AccordionSummary>
                                <Typography variant="body2" color="text.secondary">
                                    Use "Sign In with SSO" button above to sign in
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box component="form" sx={{ width: '100%' }} onSubmit={() => props.onClick(username, password)}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        id="username"
                                        label="Username"
                                        name="username"
                                        autoComplete="username"
                                        autoFocus
                                        value={username}
                                        onChange={handleUsernameChange}
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                    />
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3 }}
                                        onClick={() => props.onClick(username, password)}
                                    >
                                        Sign In
                                    </Button>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    </Card>
                </ScaleIn>
            </FadeIn>
        </Container>
    );
}
